import { HttpHeaders } from '@angular/common/http';
import { createAppSyncLink, AUTH_TYPE } from 'aws-appsync';
import { getMainDefinition } from '@apollo/client/utilities';
import { ApolloLink, Operation } from 'apollo-link';
import { HttpLink } from 'apollo-angular-link-http';
import { ConfigService } from '../services/config/config.service';

function accountNameAuthInterceptor(operation: Operation) {
    const accountNameField = 'name';
    const customerIDField = 'customerID';

    let name = window.location.host.split('.')[0];
    if (name === 'localhost:4200') {
        name = 'jenellepetsoftware';
    }
    const customerID = localStorage.getItem('Customer_ID');
    if (name) {
        operation.variables[accountNameField] = name;
    }

    if (customerID) {
        operation.variables[customerIDField] = parseInt(customerID);
    }
    return operation;
}
function apiKeyAuthInterceptor(
    operation: Operation,
    configService: ConfigService
) {
    operation.setContext({
        headers: new HttpHeaders().set(
            'x-api-key',
            configService.config.onlineStoreServiceApiKey
        ),
    });
    return operation;
}

export function createLink(
    httpLink: HttpLink,
    configService: ConfigService
): any {
    const http = httpLink.create({
        uri: configService.config.onlineStoreService,
    });

    const awsAppSyncLink: ApolloLink = createAppSyncLink({
        url: configService.config.onlineStoreService,
        region: configService.config.appSyncRegion,
        auth: {
            type: AUTH_TYPE.API_KEY,
            apiKey: configService.config.onlineStoreServiceApiKey,
        },
        complexObjectsCredentials: null,
        resultsFetcherLink: http,
    });

    const links: ApolloLink[] = [awsAppSyncLink];

    const subscriptionApolloLink: ApolloLink = ApolloLink.from(links);

    const middleware: ApolloLink = new ApolloLink((operation, forward) => {
        operation = accountNameAuthInterceptor(operation);
        operation = apiKeyAuthInterceptor(operation, configService);
        return forward(operation);
    });
    return ApolloLink.split(
        // split based on operation type
        ({ query }) => {
            const definition = getMainDefinition(query);
            return (
                definition.kind === 'OperationDefinition' &&
                definition.operation === 'subscription'
            );
        },
        subscriptionApolloLink,
        middleware.concat(http)
    );
}
